<template>
  <section class="plugin-tag">
    <div class="container-fluid">
      <legend class="text-center">Sélectionner 3 Tags :</legend>
      <div class="tagList">
        <div v-for="tag in AllTag" :key="tag.id" class="px-5">
          <input
            v-model="checkedTag"
            @input="shareTag"
            type="checkbox"
            :value="tag.label"
            name="radioTag"
            :id="tag.id"
            class="input-hidden"
          />
          <label :for="tag.id">
            <p>{{ tag.label }}</p>
          </label>
        </div>
      </div>
      <div class="text-center newtag">
        <form class="newtag" @submit.prevent="submitTag">
          <p class="text-center py-2">Ou créer un nouveau TAG</p>
          <input type="text" id="tag" name="tag" v-model="addTag" />
          <button type="submit" class="btn-primary">ajouter</button>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "UploadTag",
  components: {},
  created: function () {
    // a function to call getposts action
    this.GetAllTag();
  },
  data() {
    return {
      addTag: "", // new tag created
      checkedTag: [], // array selected by the user
      tagsArray: [], // array to store tags in the required format
    };
  },
  computed: {
    ...mapGetters({
      AllTag: "StateAllTag",
    }),
    isLoggedIn: function () {
      return this.$store.getters.isAuthenticated;
    },
  },
  watch: {
    checkedTag(newValue) {
      this.$emit("tag-choice", newValue);
    },
  },
  methods: {
    ...mapActions(["CreateTag", "GetAllTag"]),
    async submitTag() {
      try {
        let formData = new FormData();
        formData.append("label", this.addTag);
        formData = Object.fromEntries(formData.entries());
        await this.CreateTag(formData);
        this.showError = false;
      } catch (error) {
        this.showError = true;
      }
    },
    shareTag() {
      this.$emit("tag-choice", this.checkedTag);
    },
  },
};
</script>

<style lang="scss" scoped>
.plugin-tag {
  margin-bottom: 20px;
  legend {
    margin-bottom: 40px;
  }
  & .tagList {
    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-start;
    flex-wrap: wrap;
    width: 90vw;
    overflow: auto;
    padding: 10px 20px;
    background-color: $color-darker;
    border-radius: 10px;
    border: 1px outset $color-darker;
    margin: 10px auto 40px auto;
    & .input-hidden {
      position: relative;
      opacity: 0;
      z-index: 10;
      width: 100%;
      height: 40px;
      top: 30%;
    }
    & input[type="checkbox"]:checked + label > p {
      border: 0.1px inset $color-primary;
      box-shadow: 0 0 3px 3px $color-secondary;
    }

    // Stuff after this is only to make things more pretty
    & input[type="checkbox"] + label > p {
      border: 1px outset #444;
      transition: 500ms all;
    }
    & label {
      z-index: 1;
      & p {
        cursor: pointer;
        padding: 5px 10px;
        border: 0.1px inset $color-darker;
        border-radius: 10px;
        font-size: 1em;
        color: $color-secondary;
      }
    }
  }
  .newtag {
    display: flex;
    flex-direction: column;
    align-items: center;
    & p {
      font-size: 0.7em;
    }
    & input {
      font-size: 1em;
      padding: 5px 10px;
      border: 0.1px $color-primary outset;
      border-radius: 30px;
      background-color: $color-text-light;
      color: $color-primary;
    }
    & button {
      margin-top: 10%;
      margin-bottom: 10%;
      border: 0.5px $color-primary outset;
      border-radius: 1.5rem;
      padding: 4px 8px;
      background: $color-darker;
      color: $color-text-light;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.2s ease-in-out;
      &:hover {
        border: 0.5px $color-primary inset;
        background-color: $color-primary;
        color: $color-text-light;
        transform: scale(97%);
      }
    }
  }
}
</style>
